import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LightbulbOnIcon from 'icons/LightbulbOn.icon';
import UploadCloudIcon from 'icons/UploadCloud.icon';
import { Button } from 'ncoded-component-library';
import { useNavigate } from 'react-router-dom';
import QuestionMarkCircleIcon from 'icons/QuestionMarkCircle.icon';
import AddProfileIcon from 'icons/AddProfile.icon';
import { getDataRoomRoute } from 'utils';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import DataRoomUploadContext from 'router/subrouters/DataRoom/providers/DataRoomUpload/DataRoomUpload.context';
import CreateFaqDrawer from 'router/subrouters/DataRoom/pages/Faq/components/CreateFaqDrawer';
import useCallbackRef from 'hooks/useCallbackRef';
import { CreateFaqRef } from 'router/subrouters/DataRoom/pages/Faq/components/CreateFaqDrawer/CreateFaqDrawer.component';

import './SuggestedActionsEmptyState.styles.scss';

type SuggestedActionsEmptyStateProps = {
  className?: string;
};

const SuggestedActionsEmptyState: React.FC<SuggestedActionsEmptyStateProps> = (
  props,
) => {
  const { className } = props;

  const [faqDrawer, faqDrawerRef] = useCallbackRef<CreateFaqRef>(null);

  const {
    canUserAddFAQ,
    doesntHaveAccess,
    dataRoom: { _id },
  } = useContext(DataRoomContext);
  const { onUploadClick } = useContext(DataRoomUploadContext);

  const classes = classNames('suggested-actions-empty-state', className);

  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className={classes}>
      <span className="icon">
        <LightbulbOnIcon />
      </span>

      <p>{t('suggestedActionsEmpty')}</p>

      <p className="dashboard__empty">{t('keepDataRoomActive')}</p>

      <div className="actions">
        <Button
          icon={UploadCloudIcon}
          disabled={doesntHaveAccess}
          onClick={onUploadClick}
        >
          {t('uploadFiles')}
        </Button>
        {canUserAddFAQ && (
          <Button
            icon={QuestionMarkCircleIcon}
            disabled={doesntHaveAccess}
            onClick={() => faqDrawer?.setOpen(true)}
          >
            {t('addFaqs')}
          </Button>
        )}
        <Button
          icon={AddProfileIcon}
          disabled={doesntHaveAccess}
          onClick={() => navigate(getDataRoomRoute(_id, 'members'))}
        >
          {t('inviteMembers')}
        </Button>
      </div>

      {canUserAddFAQ && <CreateFaqDrawer ref={faqDrawerRef} />}
    </div>
  );
};

export default SuggestedActionsEmptyState;
